import { useQuery } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { calendarApi } from '../api'
import { CalendarCard } from '../types'

export const useCalendar = () => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date())
  const [currentMonth, setCurrentMonth] = useState<Date>(new Date())
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [cardsForSelectedDate, setCardsForSelectedDate] = useState<
    CalendarCard[]
  >([])

  // Joriy oy va yilni olish
  const currentYear = currentMonth.getFullYear()
  const currentMonthNum = currentMonth.getMonth() + 1

  // React Query bilan ma'lumotlarni olish
  const {
    data: cards = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['calendarCards', currentYear, currentMonthNum],
    queryFn: () =>
      calendarApi.getCardsByMonth({
        year: currentYear,
        month: currentMonthNum,
      }),
    enabled: true,
  })

  // Cardlarni datelar bilan gruppalash
  const cardsByDate = useMemo(() => {
    const grouped: Record<string, CalendarCard[]> = {}

    cards.forEach((card) => {
      if (card.dueDate) {
        const dateStr = card.dueDate

        if (!grouped[dateStr]) {
          grouped[dateStr] = []
        }
        grouped[dateStr].push(card)
      }
    })

    return grouped
  }, [cards])

  // Tanlangan sanadagi cardlarni olish
  const getCardsForDate = (date: Date): CalendarCard[] => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const dateStr = `${year}-${month}-${day}`

    return cardsByDate[dateStr] || []
  }

  // Calendar o'zgarganida (oy saylandi)
  const handleActiveStartDateChange = (activeStartDate: Date | null) => {
    if (activeStartDate) {
      setCurrentMonth(activeStartDate)
    }
  }

  // Date bosilganda
  const handleDateClick = (date: Date) => {
    setSelectedDate(date)
    const cardsForDate = getCardsForDate(date)
    setCardsForSelectedDate(cardsForDate)
    if (cardsForDate.length > 0) {
      setIsModalOpen(true)
    }
  }

  // Cardning rangini olish
  const getCardColor = (card: CalendarCard) => {
    const colors = [
      '#3b82f6', // blue
      '#ef4444', // red
      '#8b5cf6', // purple
      '#10b981', // green
      '#f59e0b', // yellow
      '#6366f1', // indigo
      '#ec4899', // pink
      '#06b6d4', // cyan
    ]
    return colors[card.boardId % colors.length]
  }

  return {
    cards,
    cardsByDate,
    selectedDate,
    currentMonth,
    isModalOpen,
    cardsForSelectedDate,
    isLoading,
    error,
    getCardsForDate,
    getCardColor,
    handleDateClick,
    handleActiveStartDateChange,
    setSelectedDate,
    setIsModalOpen,
    setCardsForSelectedDate,
  }
}
